var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoldFilter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Iconly_Bold_Filter_Copy",
    "data-name": "Iconly/Bold/Filter Copy",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    d: "M8.2,9a2.15,2.15,0,1,1,2.149,2.112A2.131,2.131,0,0,1,8.2,9ZM.942,9.951a.926.926,0,1,1,0-1.852h4.11a.926.926,0,1,1,0,1.852ZM0,2.112A2.131,2.131,0,0,1,2.149,0,2.131,2.131,0,0,1,4.3,2.112,2.131,2.131,0,0,1,2.149,4.224,2.131,2.131,0,0,1,0,2.112Zm7.449.926a.926.926,0,1,1,0-1.851h4.11a.926.926,0,1,1,0,1.851Z",
    fill: "#200e32"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Filter",
    transform: "translate(1.25 1.875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask-2",
    "data-name": "Mask",
    d: "M8.2,9a2.15,2.15,0,1,1,2.149,2.112A2.131,2.131,0,0,1,8.2,9ZM.942,9.951a.926.926,0,1,1,0-1.852h4.11a.926.926,0,1,1,0,1.852ZM0,2.112A2.131,2.131,0,0,1,2.149,0,2.131,2.131,0,0,1,4.3,2.112,2.131,2.131,0,0,1,2.149,4.224,2.131,2.131,0,0,1,0,2.112Zm7.449.926a.926.926,0,1,1,0-1.851h4.11a.926.926,0,1,1,0,1.851Z",
    fill: "#200e32"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color-2",
    "data-name": "Color",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color-3",
    "data-name": "Color",
    transform: "translate(-1.25 -1.875)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "color_background",
    "data-name": "color/background",
    width: 15,
    height: 15,
    rx: 4,
    fill: "#f5f6f6"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoldFilter);
export default __webpack_public_path__ + "static/media/Bold-Filter.847c1f429a3415da8ca57888737f446e.svg";
export { ForwardRef as ReactComponent };